class environment {
  production = true;
  static CaseMetricsMenuItemRequired = false;
  static tenantId = '5dd26b2c-f9ff-42c2-b121-4f41826569cc';
  static clientId = 'ad780869-7941-4fda-a409-8a040622706b';
  static authority = "https://login.microsoftonline.com/5dd26b2c-f9ff-42c2-b121-4f41826569cc";
  static ApplicationURI = 'https://crt.tqklaw.com/crt';
  static ApplicationName = 'crt';
  static teamsPopupPath = '/crt/teamsauthpopup';
  static azureGroupId = 'a4907d86-1e01-4d97-8673-1442a599d050';
  static getAccessToken = 'https://crt.tqklaw.com/crt-services/api/v1.0/user/secure/aad';
  static getUserDetails = 'https://crt.tqklaw.com/crt-services/api/v1.0/user/user-details/';
  static getCasesInfoCount = 'https://crt.tqklaw.com/crt-services/api/v1.0/cases/filter/count';
  static getCaseInfoList = 'https://crt.tqklaw.com/crt-services/api/v1.0/cases/filter';
  static postCaseInfoDetails = 'https://crt.tqklaw.com/crt-services/api/v1.0/cases/save';
  static postBulkCaseInfoDetails = 'https://crt.tqklaw.com/crt-services/api/v1.0/cases/save-multi-case/';
  static getAllSupervisors = 'https://crt.tqklaw.com/crt-services/api/v1.0/cases/all-supervisor-names';
  //static getAllAttorneys = 'https://crt.tqklaw.com/crt-servicesapi/v1.0/cases/all-attorney-names';
  static getAllAttorneys = 'https://crt.tqklaw.com/crt-services/api/v1.0/cases/attorney-names-user-id/';
  static getCaseInfoByID = 'https://crt.tqklaw.com/crt-services/api/v1.0/cases/case-info-by-id/';
  static getCaseReportHistoryByID = 'https://crt.tqklaw.com/crt-services/api/v1.0/case-report-history/';
  static postDocuments = 'https://crt.tqklaw.com/crt-services/api/v1.0/document/upload-client-report';
  static postCaseReportDetails = 'https://crt.tqklaw.com/crt-services/api/v1.0/cases/save-case-report-history';
  static getDocuments = 'https://crt.tqklaw.com/crt-services/api/v1.0/document/download-client-report';
  static updateIsActive = 'https://crt.tqklaw.com/crt-services/api/v1.0/cases/updateIsActiveStatus';
  static checkCaseName = 'https://crt.tqklaw.com/crt-services/api/v1.0/cases/casename-exist';
  static postRemindermail = 'https://crt.tqklaw.com/crt-services/api/v1.0/cases/reminder';
  static getAllUsers = 'https://crt.tqklaw.com/crt-services/api/v1.0/user/secure';
  static getAllUserDetails = 'https://crt.tqklaw.com/crt-services/api/v1.0/user/all-user-details';
  static getUserCount = 'https://crt.tqklaw.com/crt-services/api/v1.0/user/filter/count';
  static saveUser = 'https://crt.tqklaw.com/crt-services/api/v1.0/user/save';
  static getCaseUpdateHistory = 'https://crt.tqklaw.com/crt-services/api/v1.0/casehistory/audit/case/';
  static saveCaseMetricsByDates = 'https://crt.tqklaw.com/crt-services/api/v1.0/case-metrics/savewithfilter';
  static getCasesMetricList = 'https://crt.tqklaw.com/crt-services/api/v1.0/case-metrics/filter';
  static getCasesMetricCount = 'https://crt.tqklaw.com/crt-services/api/v1.0/case-metrics/filter/count';
  static getLoginHistorybyFilter = 'https://crt.tqklaw.com/crt-services/api/v1.0/loginhistory/filter';
  static postLoginHistory = 'https://crt.tqklaw.com/crt-services/api/v1.0/loginhistory/save';
  static removeUser = 'https://crt.tqklaw.com/crt-services/api/v1.0/user/';
  static casesTransfers = 'https://crt.tqklaw.com/crt-services/api/v1.0/cases/transfers';

}
export default environment;